import styled from "styled-components/macro";

export const Container = styled.div`
  padding: 24px;
  border: 1px solid var(--grey-3);
  background: var(--menu-color);
  display: flex;
  flex-direction: column;
  gap: 16px;
  border-radius: 14px;
  margin-bottom: 16px;
  position: relative;

  .stageHeader {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 4px;
  }

  .stageHeader h3 {
    margin: 0;
  }

  .instructionRow {
    display: grid;
    grid-template-columns: minmax(110px, 170px) minmax(0, 1fr);
    align-items: start;
    gap: 16px;
  }

  .instructionLabel {
    margin: 10px 0 0;
    color: var(--grey-1);
    font-weight: 500;
  }

  .instructionField {
    min-width: 0;
  }

  .instructionPromptField {
    width: calc(100% - 24px);
  }

  .instructionField label {
    margin-bottom: 0;
  }

  .instructionField .error {
    margin-top: 8px;
  }

  .modelField {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
  }

  .modelSelect {
    flex: 0 1 auto;
    width: fit-content;
    min-width: 0;
    max-width: 100%;
  }

  .modelSelectDropdown {
    position: relative;
  }

  .modelSelectTrigger {
    width: auto;
    max-width: 100%;
    min-height: 44px;
    border: 1px solid var(--grey-3) !important;
    border-radius: 12px;
    background: var(--menu-color) !important;
    color: var(--grey-0) !important;
    font-family: Inter, sans-serif;
    font-size: 16px;
    line-height: 1.3;
    font-weight: 500;
    padding: 0 10px 0 14px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    cursor: pointer;
    transition: background-color 120ms ease-in-out, border-color 120ms ease-in-out;
  }

  .modelSelectTrigger:hover {
    background: var(--grey-3) !important;
    border-color: var(--grey-3) !important;
  }

  .modelSelectTrigger:active {
    background: var(--menu-color-active) !important;
    border-color: var(--menu-color-active) !important;
  }

  .modelSelectTrigger:focus-visible {
    outline: 2px solid var(--primary-cta-high-contrast);
    outline-offset: 2px;
  }

  .modelSelectTriggerLabel {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: left;
  }

  .modelSelectTriggerCaret {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
  }

  .modelSelectTriggerCaretIcon {
    width: 14px;
    height: 10px;
  }

  .modelSelectTriggerCaretIcon path {
    fill: var(--grey-2) !important;
  }

  .advancedSettingsButton .icon-wrapper svg path {
    stroke: var(--grey-0) !important;
  }

  .advancedSettingsButton .icon-wrapper svg circle {
    fill: var(--menu-color) !important;
    stroke: var(--grey-0) !important;
  }

  .modelSelectMenu {
    position: absolute;
    top: calc(100% + 8px);
    left: 0;
    z-index: 22000;
  }

  .modelSelectMenuList {
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    max-height: 260px;
    width: min(26rem, calc(100vw - 80px));
  }

  .modelSelectSearch {
    position: sticky;
    top: 0;
    z-index: 2;
    background: var(--menu-color);
    padding: 4px 4px 8px;
    margin-bottom: 6px;
    border-bottom: 1px solid var(--grey-3);
  }

  .modelSelectSearchInput {
    width: 100%;
    height: 36px;
    border: 1px solid var(--grey-3);
    border-radius: 10px;
    background: var(--menu-color);
    color: var(--grey-0);
    padding: 0 10px;
    font-size: 14px;
    line-height: 1.3;
    box-sizing: border-box;
  }

  .modelSelectSearchInput:focus {
    border-color: var(--primary-cta-high-contrast);
    outline: 2px solid color-mix(in srgb, var(--primary-cta-high-contrast) 45%, transparent);
    outline-offset: 0;
  }

  .modelSelectOption {
    width: 100%;
    text-align: left;
    cursor: pointer;
    transition: all 120ms ease-in-out;
    border-radius: 12px;
    padding: 9.5px 12px;
    color: var(--grey-0) !important;
    background: transparent !important;
    border: none !important;
  }

  .modelSelectOption:active {
    background: var(--menu-color-active) !important;
    transform: scale(0.99);
  }

  .modelSelectOption:hover {
    background: var(--menu-color-hover) !important;
  }

  .modelSelectOption--highlighted {
    background: var(--menu-color-hover) !important;
  }

  .modelSelectOptionText {
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .modelSelectOptionLabel {
    margin: 0;
    line-height: 1.2;
    font-weight: 500;
    color: var(--grey-0);
  }

  .modelSelectOptionDescription {
    margin: 0;
    line-height: 1.25;
    color: var(--grey-1);
    font-size: 0.78rem;
  }

  .modelSelectNoResults {
    padding: 10px 12px;
    color: var(--grey-1);
    font-size: 0.85rem;
  }

  .instructionHint {
    grid-column: 2;
    margin-top: -8px;
  }

  .advancedSettingsPlacement {
    margin-top: -6px;
  }

  .advancedSettingsSpacer {
    min-height: 1px;
  }

  .advancedSettings {
    border: 1px solid var(--grey-3);
    border-radius: 14px;
    padding: 16px;
    background: var(--menu-color);
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .advancedSettingsStack {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .advancedSettingsStack .select {
    margin-bottom: 0;
    display: block;
    width: 100%;
  }

  .advancedSettingsStack h3 {
    color: var(--grey-0);
    font-weight: 500;
    margin-bottom: 6px;
  }

  .advancedSettingsStack p {
    color: var(--grey-1);
  }

  .sliderField {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .sliderFieldHeader {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 8px;
  }

  .sliderFieldTitle {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    min-width: 0;
  }

  .sliderFieldHeader h3 {
    margin: 0;
  }

  .sliderFieldHeader span {
    color: var(--grey-1);
    font-weight: 600;
    font-size: 0.95rem;
  }

  .restoreSettingButton {
    margin: 0 !important;
  }

  .restoreSettingButton .icon-wrapper svg path {
    fill: var(--grey-1) !important;
  }

  .sliderField {
    padding: 2px 0 0;
  }

  .sliderField .rc-slider {
    margin: 3px 2px 0;
  }

  .sliderField .rc-slider-rail {
    background: var(--slider-rail);
    height: 8px;
    border-radius: 999px;
  }

  .sliderField .rc-slider-track {
    background: var(--slider-track);
    height: 8px;
    border-radius: 999px;
  }

  .sliderField .rc-slider-handle {
    width: 18px;
    height: 18px;
    margin-top: -5px;
    border: 2px solid var(--slider-track);
    background: var(--menu-color);
    box-shadow: var(--slider-handle-drop-shadow);
    opacity: 1;
  }

  .sliderField .rc-slider-handle:focus-visible {
    outline: 2px solid var(--primary-cta-high-contrast);
    outline-offset: 2px;
  }

  .sliderBounds {
    display: flex;
    justify-content: space-between;
    color: var(--grey-1);
    font-size: 0.82rem;
    margin-top: 8px;
    gap: 12px;
  }

  .sliderBounds--semantic {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    font-size: 0.78rem;
    line-height: 1.25;
  }

  .sliderBounds--semantic span:last-child {
    text-align: right;
  }

  .advancedSettingsStack input {
    border: 1.5px solid var(--grey-2);
    border-radius: 8px;
    padding: 12px;
    margin-top: 8px;
    display: block;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
    font-family: Inter, sans-serif;
    font-size: 16px;
    font-weight: 500;
    background: var(--menu-color);
    color: var(--grey-0);
  }

  .advancedSettingsStack input:focus {
    border: 1.5px solid var(--primary-cta);
  }

  .stopField input {
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
  }

  .stopField {
    margin-top: 8px;
  }

  .stopFieldHeader {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 12px;
  }

  .stopFieldHeader h3 {
    margin: 0;
  }

  .stopFieldHint {
    color: var(--grey-1);
    font-size: 0.75rem;
    line-height: 1.25;
    text-align: right;
  }

  .generationsField .menu-select-wrapper {
    width: 100%;
    max-width: none;
    margin-top: 10px;
  }

  .generationsField .menu-select-wrapper--cards-count p {
    color: var(--grey-0) !important;
  }

  .generationsField {
    margin-top: 8px;
  }

  .maxTokensField {
    width: 100%;
  }

  .maxTokensField > p {
    margin-top: 4px;
  }

  .advancedSettingsMotion {
    overflow: hidden;
  }

  @media (max-width: 900px) {
    padding: 16px;

    .instructionRow {
      grid-template-columns: 1fr;
      gap: 8px;
    }

    .instructionLabel {
      margin: 0;
    }

    .instructionHint {
      grid-column: auto;
      margin-top: 0;
    }

    .instructionPromptField {
      width: 100%;
    }
  }
`;
